/** Render a recorded date without turning a date-only promise into an instant. */
export function formatShipmentDate(
  value: string,
  precision: "DATE" | "INSTANT",
  language: string,
  timeZone?: string
): string | null {
  const date = new Date(precision === "DATE" ? `${value}T00:00:00Z` : value);
  if (!Number.isFinite(date.getTime())) return null;
  if (precision === "DATE" && date.toISOString().slice(0, 10) !== value)
    return null;
  const locale = language === "zh" ? "zh-CN" : "en-CA";
  if (precision === "DATE") {
    return new Intl.DateTimeFormat(locale, {
      dateStyle: "medium",
      timeZone: "UTC",
    }).format(date);
  }
  // Unknown recorded zone: show the known instant explicitly in UTC, never the viewer's zone.
  let recordedZone = "UTC";
  if (timeZone) {
    try {
      new Intl.DateTimeFormat(locale, { timeZone });
      recordedZone = timeZone;
    } catch {
      /* Invalid legacy zone does not establish a local wall-clock time. */
    }
  }
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: recordedZone,
    timeZoneName: "short",
  }).format(date);
}
